export default class Singleton {
  static getInstance() {
    if (this.instance == null) {
      this.instance = new this()
    }
    return this.instance
  }
}